// extracted by mini-css-extract-plugin
export var active = "Tab-module--active--70062";
export var tab = "Tab-module--tab--54a5f";